import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Chip, Divider, Grid2, IconButton, Paper, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
import { useGetPMDataQuery } from "store/slices/apis/pmDashboardSlice";
import ExportToExcel from "view/projectLanding/Risk/ExportToExcel";
import ExportToPDF from "view/projectLanding/Risk/ExportToPDF";


const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%',
}));

export default function PMPopup({ title, value, status, onClose, onOpen }) {
    const theme = useTheme();
    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = React.useState(1);
    let searchparams = {
        projectId: projectId,
        page: pageNumber,
        pageSize: 10,
        sortBy: 'createddate',
        sortOrder: 'desc',
        approved_status: 'Approved',
    }

    if (status == 'TotalEquipments') {
        searchparams = {
            ...searchparams,
        }
    }
    else if (status == 'ActualAvailable') {
        searchparams = {
            ...searchparams,
            hasActualDate: true
        }
    }
    else if (status == 'OwnedvsHired') {
        searchparams = {
            ...searchparams,
            owned: value?.status
        }
    }
    else {
        searchparams = {
            ...searchparams,
        }
    }

    const { data: openCloseData = {}, error: openCloseError, isLoading: isOpenCloseLoading } = useGetPMDataQuery(searchparams);

    const columns = [
        // {
        //     name: "PM ID",
        //     field: "pm_number",
        //     renderExport: (row) => row?.pm_number || "N.A.",
        // },
        // {
        //     name: "Consultant/Contractor",
        //     field: "consultant_contractor",
        //     renderExport: (row) => row?.consultant_contractor || "N.A.",
        // },
        {
            name: "PM Name",
            field: "pm",
            renderExport: (row) => row?.pm || "N.A.",
        },
        {
            name: "Category",
            field: "category",
            renderExport: (row) => row?.category || "N.A.",
        },
        {
            name: "Owned",
            field: "owned",
            renderer(params) {
                return <>{params?.owned ? "True" : "False"}</>;
            },
            renderExport: (row) => (row?.owned ? "True" : "False"),
        },
        // {
        //     name: "Quantity",
        //     field: "quantity",
        //     renderExport: (row) => row?.quantity ?? "N.A.",
        // },
        // {
        //     name: "Created Date",
        //     field: "createddate",
        //     renderer(params) {
        //         return (
        //             <>
        //                 {params?.createddate
        //                     ? moment(params.createddate).format("DD/MM/YY")
        //                     : "N.A."}
        //             </>
        //         );
        //     },
        //     renderExport: (row) =>
        //         row?.createddate ? moment(row.createddate).format("DD/MM/YY") : "N.A.",
        // },
        {
            name: "Plan Deployment Date",
            field: "plannedDate",
            field: "plannedDate",
            renderer(params) {
                return (
                    <>
                        {params?.plannedDate
                            ? moment(params.plannedDate).format("DD/MM/YY")
                            : "N.A."}
                    </>
                );
            },
            renderExport: (row) =>
                row?.plannedDate ? moment(row.plannedDate).format("DD/MM/YY") : "N.A.",
        },
        {
            name: "Actual Deployment Date",
            field: "actualDate",
            renderer(params) {
                return (
                    <>
                        {params?.actualDate
                            ? moment(params.actualDate).format("DD/MM/YY")
                            : "N.A."}
                    </>
                );
            },
            renderExport: (row) =>
                row?.actualDate ? moment(row.actualDate).format("DD/MM/YY") : "N.A.",
        },
    ];


    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                onClose={onClose}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 container spacing={2} size={12}>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToExcel data={openCloseData?.data} columns={columns} fileName="p&m_export" />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToPDF data={openCloseData?.data} columns={columns} fileName="p&m_export" />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={openCloseData?.data} isLoading={isOpenCloseLoading} />

                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={openCloseData?.pagination?.currentPage || 1}
                                        totalPages={openCloseData?.pagination?.totalPages || 1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box>

                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}